
import React, { useCallback, useContext, useEffect, useState } from 'react';
import '../../../../libs/bulma.min.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneSquare } from '@fortawesome/free-solid-svg-icons';

function FormIPInterfaces(props) {
  const { handleChangeValues, trunks, remove } = props;

  return (
    <div name="change-entrance-div" className="is-align-content-center">
      <div className="columns mx-2">
        <div className="column is-2 field mt-2">
          <label className="label">Multi-Configuração
            <div className="control">
              <div name="only" className="select is-fullwidth">
                <select className="select" name="only" onChange={(e) => handleChangeValues(e.target)} >
                  <option value="">Selecione</option>
                  <option value={ true }> Sim </option>
                  <option value={ false }> Não </option>
                </select>
                <p name="only-placeholder-data" className='has-text-grey-dark is-size-7'>Haverá mais de um tronco?</p>
                <p name="only-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
              </div>
            </div>
          </label>
        </div>
        <div className="column is-2 field mt-2">
          <label className="label">Tipo
            <div className="control">
              <div name="type" className="select is-fullwidth">
                <select className="select" name="type" onChange={(e) => handleChangeValues(e.target)} >
                  <option value="">Selecione</option>
                  <option value="emergency"> Emergência </option>
                  <option value="free"> 0800 </option>
                  <option value="local"> Fixo Local </option>
                  <option value="mobile"> Celular Local </option>
                  <option value="ddd"> Fixo DDD </option>
                  <option value="ddd-mobile"> Celular DDD </option>
                  <option value="international"> Internacional </option>
                </select>
                <p name="type-placeholder-data" className='has-text-grey-dark is-size-7'>Tipo de chamadda de saída.</p>
                <p name="type-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
              </div>
            </div>
          </label>
        </div>
        <div className="column is-2 field mt-2 my-2">
          <label className="label">Máscara de Saída
            <div className="control">
              <input className="input" name="mask" type="text" placeholder="ZXXXXXXX" onBlur={(e) => handleChangeValues(e.target)} />
              <p name="mask-placeholder-data" className='has-text-grey-dark is-size-7'>Dígitos recebidos da operadora.</p>
              <p name="mask-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
            </div>
          </label>
        </div>
        <div className="column is-1 field mt-2">
          <label className="label">Tempo
            <div className="control">
              <input className="input" name="timeout" type="number" placeholder="Mín. 5s" onBlur={(e) => handleChangeValues(e.target)} />
              <p name="timeout-placeholder-data" className='has-text-grey-dark is-size-7'>Duração toque.</p>
              <p name="timeout-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos.</p>
            </div>
          </label>
        </div>
        <div className="column is-2 field mt-2">
          <label className="label">Tronco de Saída
            <div className="control">
              <div name="trunk" className="select is-fullwidth">
                <select className="select" name="trunk" onChange={(e) => handleChangeValues(e.target)} >
                  <option value="">Selecione</option>
                  { trunks.map((trunk) => <option key={ trunk } value={ trunk }>{ trunk }</option>) }
                </select>
                <p name="trunk-placeholder-data" className='has-text-grey-dark is-size-7'>Tronco de recepção das chamadas.</p>
                <p name="trunk-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
              </div>
            </div>
          </label>
        </div>
        <div className="column is-1 field mt-2">
          <label className="label">Prefixo
            <div className="control">
              <div name="remove-status" className="select is-fullwidth">
                <select className="select" name="remove-status" onChange={(e) => handleChangeValues(e.target)} >
                  <option value="">Selecione</option>
                  <option value={ true }> Sim </option>
                  <option value={ false }> Não </option>
                </select>
                <p name="remove-status-placeholder-data" className='has-text-grey-dark is-size-7'>Remover?</p>
                <p name="remove-status-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
              </div>
            </div>
          </label>
        </div>
        <div className="column is-1 field mt-2">
          <label className="label">QTD
            <div className="control">
              <input className="input" name="remove-qtt" type="number" placeholder="4" onBlur={(e) => handleChangeValues(e.target)} disabled={ remove } />
              <p name="remove-qtt-placeholder-data" className='has-text-grey-dark is-size-7'>Quantidade.</p>
              <p name="remove-qtt-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos.</p>
            </div>
          </label>
        </div>
        <div className="column is-1 field mt-2">
          <label className="label">Operadora
            <div className="control">
              <input className="input" name="code" type="text" placeholder="015" onBlur={(e) => handleChangeValues(e.target)} disabled={ remove } />
              <p name="code-placeholder-data" className='has-text-grey-dark is-size-7'>Código.</p>
              <p name="code-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos.</p>
            </div>
          </label>
        </div>
      </div>
      <br/>
    </div>
  );
}

export default FormIPInterfaces;
